/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Basegame_Partofbundle3Inputs */

const id_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran ini adalah bagian dari`)
};

const ms_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran ini adalah sebahagian daripada`)
};

const da_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette tilbud er en del af`)
};

const de_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Angebot ist Teil von`)
};

const en_us2_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This offer is part of`)
};

const es_es2_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta oferta es parte de`)
};

const es_mx2_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta oferta es parte de`)
};

const fil_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang offer na ito ay bahagi ng`)
};

const fr_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette offre fait partie de`)
};

const it_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa offerta fa parte di`)
};

const hu_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez az ajánlat része a`)
};

const nl_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit aanbod maakt deel uit van`)
};

const no_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette tilbudet er en del av`)
};

const pl_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta oferta jest częścią`)
};

const pt_br2_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This offer is part of`)
};

const pt_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta oferta faz parte de`)
};

const ro_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Această ofertă face parte din`)
};

const fi_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä tarjous on osa`)
};

const sv_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detta erbjudande är en del av`)
};

const vi_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi này là một phần của`)
};

const tr_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu teklif şunun parçasıdır:`)
};

const cs_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tato nabídka je součástí`)
};

const bg_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тази оферта е част от`)
};

const ru_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это предложение является частью`)
};

const uk_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ця пропозиція є частиною`)
};

const ar_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا العرض جزء من`)
};

const hi_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह ऑफ़र इसका हिस्सा है`)
};

const th_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอนี้เป็นส่วนหนึ่งของ`)
};

const ja_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このオファーは次の一部です：`)
};

const zh_cn2_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This offer is part of`)
};

const zh_hant1_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This offer is part of`)
};

const ko_components_basegame_partofbundle3 = /** @type {(inputs: Components_Basegame_Partofbundle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This offer is part of`)
};

/**
* | output |
* | --- |
* | "This offer is part of" |
*
* @param {Components_Basegame_Partofbundle3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_basegame_partofbundle3 = /** @type {((inputs?: Components_Basegame_Partofbundle3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Basegame_Partofbundle3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_basegame_partofbundle3(inputs)
	if (locale === "ms") return ms_components_basegame_partofbundle3(inputs)
	if (locale === "da") return da_components_basegame_partofbundle3(inputs)
	if (locale === "de") return de_components_basegame_partofbundle3(inputs)
	if (locale === "en-US") return en_us2_components_basegame_partofbundle3(inputs)
	if (locale === "es-ES") return es_es2_components_basegame_partofbundle3(inputs)
	if (locale === "es-MX") return es_mx2_components_basegame_partofbundle3(inputs)
	if (locale === "fil") return fil_components_basegame_partofbundle3(inputs)
	if (locale === "fr") return fr_components_basegame_partofbundle3(inputs)
	if (locale === "it") return it_components_basegame_partofbundle3(inputs)
	if (locale === "hu") return hu_components_basegame_partofbundle3(inputs)
	if (locale === "nl") return nl_components_basegame_partofbundle3(inputs)
	if (locale === "no") return no_components_basegame_partofbundle3(inputs)
	if (locale === "pl") return pl_components_basegame_partofbundle3(inputs)
	if (locale === "pt-BR") return pt_br2_components_basegame_partofbundle3(inputs)
	if (locale === "pt") return pt_components_basegame_partofbundle3(inputs)
	if (locale === "ro") return ro_components_basegame_partofbundle3(inputs)
	if (locale === "fi") return fi_components_basegame_partofbundle3(inputs)
	if (locale === "sv") return sv_components_basegame_partofbundle3(inputs)
	if (locale === "vi") return vi_components_basegame_partofbundle3(inputs)
	if (locale === "tr") return tr_components_basegame_partofbundle3(inputs)
	if (locale === "cs") return cs_components_basegame_partofbundle3(inputs)
	if (locale === "bg") return bg_components_basegame_partofbundle3(inputs)
	if (locale === "ru") return ru_components_basegame_partofbundle3(inputs)
	if (locale === "uk") return uk_components_basegame_partofbundle3(inputs)
	if (locale === "ar") return ar_components_basegame_partofbundle3(inputs)
	if (locale === "hi") return hi_components_basegame_partofbundle3(inputs)
	if (locale === "th") return th_components_basegame_partofbundle3(inputs)
	if (locale === "ja") return ja_components_basegame_partofbundle3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_basegame_partofbundle3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_basegame_partofbundle3(inputs)
	return ko_components_basegame_partofbundle3(inputs)
});
export { components_basegame_partofbundle3 as "components.baseGame.partOfBundle" }